import React, { useContext, useState } from 'react'
import Button from '../../../../../Forms/Button'
import ContactForm, { PrivacyContent } from '../../../../../Sidebar/components/ContactForm'
import { ReactComponent as SparxLogo } from './icons/sparx-logo.svg'
import { ReactComponent as Close } from './icons/close.svg'
import { captureEvent } from '../../../../../../analytics'
import { analyticsEvents } from '../../../../../../analytics/events'
import { AppConfigContext } from '../../../../../../context/AppConfig'
import EversetCheckoutModal from '../../../../../EversetCheckoutModal'

function PoweredBy() {
  return (
    <div className="text-[#3D4256] text-[12px] font-medium flex items-center mt-[4px]">
      <span className="mr-[6px]">Powered by</span> <div className='flex-shrink-0'><SparxLogo /></div>
    </div>
  )
}
function ContactUs({ onClose, className }) {
  const { isSWApp, isEWApp, isPDApp, isAvalonApp } = useContext(AppConfigContext)

  function getLabel() {
    if (isAvalonApp) {
      return 'Connect with Furnished Housing Team'
    }
    if (isEWApp) {
      return 'Customize and Checkout'
    }
    if (isSWApp) {
      return 'Connect with Vendor'
    }
    if (isPDApp) {
      return 'Contact Property'
    }
    return 'Contact Us'
  }

  const [cartModalShown, setCartModalShown] = useState(false)

  const [formShown, setFormShown] = useState(false)
  return (
    <>
      <Button
        className={`ml-[8px] ${isPDApp ? '' : 'w-[184px]'} ${isEWApp || isAvalonApp ? '!w-max' : ''} ${
          isPDApp ? '!bg-black' : ''
        } ${className}`}
        onClick={() => {
          captureEvent(analyticsEvents.CONTACT_US_TAPPED)
          if (isEWApp) {
            // setCartModalShown(true)
            window.open(`https://theeverset.com/cart`, '_blank')
            return
          }
          setFormShown(true)
        }}
      >
        {getLabel()}
      </Button>
      {cartModalShown && <EversetCheckoutModal onClose={() => setCartModalShown(false)} />}
      {formShown && (
        <div className="fixed top-0 left-0 w-screen h-full overflow-y-auto flex flex-col z-[40] bg-white">
          <div className="portait:h-full lg:!h-full portrait:flex-1 lg:!flex-1 px-[24px] relative">
            <button
              className="absolute top-[24px] right-[24px] z-[20]"
              onClick={() => {
                captureEvent(analyticsEvents.CORT_FORM_CLOSED)
                setFormShown(false)
              }}
            >
              <Close />
            </button>
            <ContactForm
              mobile
              onClose={() => {
                captureEvent(analyticsEvents.CORT_FORM_CLOSED)
                setFormShown(false)
              }}
            />
          </div>
          {!isPDApp && (
            <div className="flex justify-between items-center portrait:hidden lg:hidden my-[20px] px-[24px] shrink-0">
              <PrivacyContent />
              <PoweredBy />
            </div>
          )}
          <div className="bg-[#FAFAFA] flex-shrink-0 h-[54px] w-full flex-col items-center justify-center hidden portrait:flex lg:flex">
            <PoweredBy />
            <div className="text-[#3D4256] opacity-40 text-[10px] mt-[4px]">
              ® All Rights Reserved SparX Inc. {new Date().getFullYear()}
            </div>
          </div>
          {isPDApp && (
            <div className="bg-[#FAFAFA] flex-shrink-0 h-[54px] flex flex-col items-center justify-center portrait:hidden lg:hidden mt-[20px] absolute bottom-0 w-full">
              <PoweredBy />
              <div className="text-[#3D4256] opacity-40 text-[10px] mt-[4px]">
                ® All Rights Reserved SparX Inc. {new Date().getFullYear()}
              </div>
            </div>
          )}
        </div>
      )}
    </>
  )
}

export default ContactUs
